module.exports = __webpack_public_path__ + "static/media/camera.1174dd81.png";